/* ===========================
   Sticky CTA (tabs + hours)
   =========================== */
(function () {
  function getLocalTime(root) {
    const tz = root.dataset.timezone || "America/Denver";
    const now = new Date();
    const local = new Date(now.toLocaleString("en-US", { timeZone: tz }));
    return { hour: local.getHours(), day: local.getDay() };
  }

  function isChannelOpen(root, key, defaultAlways) {
    const ds = root.dataset;
    const t = getLocalTime(root);

    const open = parseInt(ds[key + "OpenHour"], 10);
    const close = parseInt(ds[key + "CloseHour"], 10);
    const weekends = ds[key + "Weekends"] === "true";

    if (Number.isNaN(open) || Number.isNaN(close)) return !!defaultAlways;

    const isWeekend = t.day === 0 || t.day === 6;

    if (open === close) {
      if (!weekends && isWeekend) return false;
      return true;
    }

    let within = t.hour >= open && t.hour < close;
    if (!weekends && isWeekend) within = false;
    return within;
  }

  function isChatOnline() {
    try {
      if (window.ShopifyInbox && typeof window.ShopifyInbox.isOnline === "function") {
        return window.ShopifyInbox.isOnline();
      }
      if (window.ShopifyChat && typeof window.ShopifyChat.isOnline === "function") {
        return window.ShopifyChat.isOnline();
      }
    } catch (e) {}
    // If we can't detect online status, don't block chat availability
    return true;
  }

  function computeAvailability(root) {
    const tabs = {
      call: root.querySelector('.sticky-cta-tab[data-mode="call"]'),
      text: root.querySelector('.sticky-cta-tab[data-mode="text"]'),
      chat: root.querySelector('.sticky-cta-tab[data-mode="chat"]')
    };

    const buttons = {
      call: root.querySelector(".sticky-cta-btn-call"),
      text: root.querySelector(".sticky-cta-btn-text"),
      chat: root.querySelector(".sticky-cta-btn-chat")
    };

    const has = {
      call: !!tabs.call && !!buttons.call,
      text: !!tabs.text && !!buttons.text,
      chat: !!tabs.chat && !!buttons.chat
    };

    const callOpen = has.call && isChannelOpen(root, "phone", false);
    const textOpen = has.text && isChannelOpen(root, "text", true);
    const chatHoursOpen = has.chat && isChannelOpen(root, "chat", false);

    let chatOpen = chatHoursOpen;
    if (chatOpen && root.dataset.chatFollowAgent === "true") {
      chatOpen = chatOpen && isChatOnline();
    }

    return { tabs, buttons, has, avail: { call: callOpen, text: textOpen, chat: chatOpen } };
  }

  function initStickyCTA() {
    const root = document.getElementById("sticky-cta");
    if (!root) return;

    const helper = root.querySelector(".sticky-cta-helper");
    let currentMode = "call";

    function pickFirstAvailable(has, avail) {
      const order = ["call", "text", "chat"];
      for (let i = 0; i < order.length; i++) {
        const m = order[i];
        if (has[m] && avail[m]) return m;
      }
      for (let i = 0; i < order.length; i++) {
        const m = order[i];
        if (has[m]) return m;
      }
      return null;
    }

    // UPDATED: helper line no longer has "closed" variants
    function setHelperLine(mode) {
      if (!helper) return;

      const map = {
        callOpen: helper.dataset.callOpen,
        textOpen: helper.dataset.textOpen,
        chatOpen: helper.dataset.chatOpen
      };

      const txt = map[mode + "Open"] || "";
      helper.textContent = txt;
      helper.style.display = txt ? "" : "none";
    }

    // NEW: when clicking our Chat CTA, open Shopify Inbox
    function openShopifyInbox() {
      const host =
        document.querySelector("inbox-online-store-chat") ||
        document.querySelector("inbox-online-store-chat-app") ||
        document.querySelector("online-store-chat") ||
        document.querySelector("shopify-chat") ||
        document.querySelector("chat-app");

      if (!host) return false;

      try {
        if (host.shadowRoot) {
          const btn =
            host.shadowRoot.querySelector("button.chat-toggle") ||
            host.shadowRoot.querySelector("button") ||
            host.shadowRoot.querySelector('[role="button"]');
          if (btn) {
            btn.click();
            return true;
          }
        }
      } catch (e) {}

      return false;
    }

    // NEW: intercept our #open-chat link and trigger Inbox
    root.addEventListener(
      "click",
      function (e) {
        const a = e.target.closest('a[href="#open-chat"]');
        if (!a) return;

        e.preventDefault();
        e.stopPropagation();

        // give Inbox a moment to mount if needed
        let tries = 0;
        const t = setInterval(function () {
          tries++;
          if (openShopifyInbox() || tries > 30) clearInterval(t); // ~3s
        }, 100);
      },
      true
    );

    function updateUI(desiredMode) {
      const { tabs, buttons, has, avail } = computeAvailability(root);

      let active = desiredMode || currentMode || "call";

      if (!has[active] || !avail[active]) {
        const fallback = pickFirstAvailable(has, avail);
        if (!fallback) {
          root.style.display = "none";
          return;
        }
        active = fallback;
      }

      currentMode = active;
      root.style.display = "";

      ["call", "text", "chat"].forEach((mode) => {
        const shouldShow = has[mode] && avail[mode];

        if (tabs[mode]) {
          tabs[mode].style.display = shouldShow ? "flex" : "none";
          tabs[mode].classList.toggle("is-active", mode === active && shouldShow);
        }
        if (buttons[mode]) {
          buttons[mode].classList.toggle("is-active", mode === active && shouldShow);
        }
      });

      // UPDATED: always use "open" helper line only
      setHelperLine(active);
    }

    updateUI("call");

    root.querySelectorAll(".sticky-cta-tab").forEach((tab) => {
      tab.addEventListener("click", () => {
        const mode = tab.dataset.mode;
        currentMode = mode;
        updateUI(mode);
      });
    });

    setInterval(() => updateUI(currentMode), 5 * 60 * 1000);
  }

  document.addEventListener("DOMContentLoaded", initStickyCTA);
  document.addEventListener("shopify:section:load", initStickyCTA);
})();

/* ==========================================
   Shopify Inbox click-steal fix (RECT-based)
   - No shadowRoot access required
   - CLOSED (small host)  => pointer-events:none  (prevents invisible overlay)
   - OPEN (large host)    => pointer-events:auto  (allows closing + chat UI)
   ========================================== */
(function () {
  function getHost() {
    return (
      document.querySelector("inbox-online-store-chat") ||
      document.querySelector("inbox-online-store-chat-app") ||
      document.querySelector("online-store-chat") ||
      document.querySelector("shopify-chat") ||
      document.querySelector("chat-app")
    );
  }

  function setPE(val) {
    const host = getHost();
    if (!host) return;
    host.style.pointerEvents = val; // "none" or "auto"
  }

  function setHostClosedHidden(isOpen) {
    const host = getHost();
    if (!host) return;

    if (isOpen) {
      host.style.opacity = "1";
      host.style.visibility = "visible";
    } else {
      host.style.opacity = "0";
      host.style.visibility = "hidden";
    }
  }

  // When user triggers #open-chat, force PE:auto briefly to let Inbox expand
  let forceAutoUntil = 0;

  document.addEventListener(
    "click",
    function (e) {
      const a = e.target.closest('a[href="#open-chat"]');
      if (!a) return;
      forceAutoUntil = Date.now() + 6000;
      setHostClosedHidden(true);
      setPE("auto");
      burstTick(); // NEW: fast re-check burst
    },
    true
  );

  function isHostOpenByRect(host) {
    const r = host.getBoundingClientRect();
    const area = r.width * r.height;

    const looksOpen =
      (r.width >= 260 && r.height >= 260) ||
      (r.height >= 420) ||
      (area >= 180000);

    return looksOpen;
  }

  function tick() {
    const host = getHost();
    if (!host) return;

    if (Date.now() < forceAutoUntil) {
      setHostClosedHidden(true);
      setPE("auto");
      return;
    }

    const openNow = isHostOpenByRect(host);

    if (!openNow) forceAutoUntil = 0;

    setHostClosedHidden(openNow);

    if (openNow) {
      setPE("auto");
    } else {
      setPE("none");
    }
  }

  // NEW: rapid tick burst for ~1.2s to catch close animations instantly
  function burstTick() {
    let i = 0;
    const t = setInterval(function () {
      tick();
      i++;
      if (i > 24) clearInterval(t); // 24 * 50ms = 1200ms
    }, 50);
  }

  // NEW: common close interactions -> run a burst so the launcher hides immediately
  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key === "Escape") burstTick();
    },
    true
  );

  document.addEventListener(
    "pointerdown",
    function (e) {
      const host = getHost();
      if (!host) return;

      // If clicking outside the host UI, likely closing (or about to)
      if (!host.contains(e.target)) burstTick();
    },
    true
  );

  window.addEventListener("blur", burstTick);
  window.addEventListener("focus", burstTick);

  function init() {
    setPE("none");
    setHostClosedHidden(false);

    if (window.__stickyInboxRectTimer) clearInterval(window.__stickyInboxRectTimer);
    window.__stickyInboxRectTimer = setInterval(tick, 200);

    let n = 0;
    const burst = setInterval(() => {
      tick();
      n++;
      if (n > 25) clearInterval(burst);
    }, 120);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();

/* ==========================================
   Sticky CTA collapse / restore (ALL screens)
   - Minimize hides bubble (adds .sticky-cta--collapsed)
   - Launcher restores bubble (removes .sticky-cta--collapsed)
   - Persists in localStorage
   - Guarded to prevent double-binding in theme editor
   ========================================== */
(function () {
  function initCollapse() {
    const root = document.getElementById("sticky-cta");
    if (!root) return;

    // Prevent duplicate listeners (theme editor reloads, etc.)
    if (root.dataset.collapseBound === "true") return;
    root.dataset.collapseBound = "true";

    const minimizeBtn = root.querySelector(".sticky-cta-minimize");
    const launcherBtn = root.querySelector(".sticky-cta-collapsed-launcher");

    function collapse() {
      root.classList.add("sticky-cta--collapsed");
      try {
        localStorage.setItem("stickyCtaCollapsed", "true");
      } catch (e) {}
    }

    function expand() {
      root.classList.remove("sticky-cta--collapsed");
      try {
        localStorage.setItem("stickyCtaCollapsed", "false");
      } catch (e) {}
    }

    // Restore previous state
    try {
      if (localStorage.getItem("stickyCtaCollapsed") === "true") {
        root.classList.add("sticky-cta--collapsed");
      }
    } catch (e) {}

    if (minimizeBtn) {
      minimizeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        collapse();
      });
    }

    if (launcherBtn) {
      launcherBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        expand();
      });
    }
  }

  document.addEventListener("DOMContentLoaded", initCollapse);
  document.addEventListener("shopify:section:load", initCollapse);
})();